import React from 'react'
import './App.css'
import SideBar from './component/layout/SideBar'
import Header from './component/layout/Header'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import jwtDecode from 'jwt-decode'
import axios from 'axios'
import { ProtectedRoute, AuthRoute } from './utilities/route/Route'
//Redux
import store from './redux/store'
import { Provider } from 'react-redux'
import { createFirestoreInstance } from 'redux-firestore'
import { ReactReduxFirebaseProvider } from 'react-redux-firebase'
import { getUserData, forceSignOut, setAuthenticated } from './redux'
//Firebase
import firebase from './config/fbConfig'
//Scenes
import LandingPage from './scenes/landingPage/LandingPage'
import CreateDocumentForm from './scenes/document/CreateDocumentForm'
import ViewDocumentTable from './scenes/document/ViewDocumentTable'
import ViewProfileTable from './scenes/profile/ViewProfileTable'
import ViewDocumentDetails from './scenes/document/ViewDocumentDetails'
import ViewMyProfile from './scenes/profile/ViewMyProfile'
import Dashboard from './scenes/dashboard/Dashboard'
import SignDocumentModal from './scenes/document/SignDocumentModal'

//react-redux-firebase config
const rrfConfig = {
  userProfile: 'Users',
  attachAuthIsReady: true, // attaches auth is ready promise to store,
  firebaseStateName: 'firebase', // should match the reducer name ('firebase' is default)
  useFirestoreForProfile: true, // Firestore for Profile instead of Realtime DB
}

const rrfProps = {
  firebase,
  config: rrfConfig,
  dispatch: store.dispatch,
  createFirestoreInstance, // <- needed if using firestore
}

const token = localStorage.FBIdToken
if (token) {
  const decodedToken = jwtDecode(token)
  if (decodedToken.exp * 1000 < Date.now()) {
    store.dispatch(forceSignOut())
    window.location.href = '/'
  } else {
    // store.dispatch(getUserData(decodedToken.user_id))
    store.dispatch(setAuthenticated())
    axios.defaults.headers.common['Authorization'] = token
  }
}
function App() {
  const DefaultContainer = () => (
    <div className='main-container'>
      <SideBar />
      <Header />
      <div className='scene-container'>
        <ProtectedRoute path='/dashboard' component={Dashboard} />
        <ProtectedRoute path='/createDocumentForm' component={CreateDocumentForm} />
        <ProtectedRoute path='/viewDocumentTable' component={ViewDocumentTable} />
        <ProtectedRoute path='/viewProfileTable' component={ViewProfileTable} />
        <ProtectedRoute path='/viewDocumentDetails/:documentId' component={ViewDocumentDetails} />
        <ProtectedRoute path='/signDocumentModal/:documentId' component={SignDocumentModal} />
        <ProtectedRoute path='/viewProfile' component={ViewMyProfile} />
      </div>
    </div>
  )

  return (
    <Provider store={store}>
      <ReactReduxFirebaseProvider {...rrfProps}>
        <div className='App'>
          <Router>
            <Switch>
              <AuthRoute exact path='/' component={LandingPage} />
              <Route component={DefaultContainer} />
            </Switch>
          </Router>

        </div>
      </ReactReduxFirebaseProvider>
    </Provider>
  )
}

export default App
